






import { Role, UserRole } from '@/types/Users'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Roles extends Vue {
  @Prop({ default: [] }) roles!: Role[]
  @Prop({ default: false }) small!: boolean

  roleName(role: Role) {
    return UserRole[role.id]
  }
}
